<div>
    <ul class="language-dp-block list-unstyled list-inline">        
        
        <li class="dropdown rel-pos lang-main">
            <!-- <i class="fa fa-language white"></i> -->
            <button class="btn-transparent cus-caret">
                <span class="">{{selectedLanguageName}}</span>
                <div class="btn-select-value cus-caret sel-country"></div>
            </button>
            <div class="language-container">
                <ul class="language-dp">                    
                    <li [class.active]="selectedLanguageName === language.languageName" *ngFor="let language of languages | orderBy:'languageName'" (click)="selectLanguage(language)">
                        {{language.languageName}}
                    </li>
                </ul>
            </div>
        </li>        
    </ul>
</div>
<!-- change country modal popup -->
<div class="template1">
    <div *ngIf="isModalShown" [config]="{ show: true,backdrop:false }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal" class="modal fade change-country" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title pull-left mar-0">Change Country</h4>
                    <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body change-country">
                    <div class="col-xs-12">
                        Changing the country will require you to select your products again. Do you want to continue?
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-xs-6"></div>
                    <div class="col-xs-6">
                        <button type="button" class="btn blue-button" (click)=" (true)">Ok</button>
                        <button type="button" class="btn blue-button" (click)="hideModal()">Cancel </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="dropdown-backdrop"></div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/country-language.component.html